/*
 *
 * Package: `@dbh/total-price-bar-theme`.
 *
 */const THEME_KEY_TOTAL_PRICE_BAR="totalPriceBar";const modifyTotalPriceBarTheme=a=>{let{spacing:{sp5:b,sp6:c,sp14:d},colors:{brandFirst:e,greyLight:f,blackMid:g},fonts:{style:{medium:h},size:{ff3:i,ff6:j},lineHeight:{l1:k}}}=a;return {[THEME_KEY_TOTAL_PRICE_BAR]:{root:{borderTop:"none",boxShadow:"0px -1px 6px "+g,padding:b+" 0 "+b+" "+c,priceHiddenPadding:b+" 0",height:d},checkoutPrice:{color:e,weight:h,size:i,lineHeight:k},slashedPrice:{color:f,weight:h,size:j}}}};

export { THEME_KEY_TOTAL_PRICE_BAR, modifyTotalPriceBarTheme as default };
